export const requestCommentsQueryKey = 'requestComments'
export const billCommentsQueryKey = 'ListBillComments'
